import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
// import { useScreenshot } from 'use-react-screenshot'
// import html2canvas from 'html2canvas';
import { toPng } from 'html-to-image';

import { Accordion, AccordionTab } from "primereact/accordion";
import "./PM_TEMPLATE.css";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { PMTemplate } from "../../../services/Template/pm-template";
import { Api } from "../../../services/api";
import { InputNumber } from "primereact/inputnumber";

import { FaCopy, FaPlus, FaTrash } from 'react-icons/fa';
import PM_TEMPLATE from "./PM_TEMPLATE";
import { set } from "react-hook-form";
import { InputTextarea } from "primereact/inputtextarea";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { color } from "framer-motion";


const EDIT_SP_TEMPLATE = ({ pmId }) => {

  const { editId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [internalJob, setInternalJob] = useState('N');

  const [projectData, setProjectData] = useState([]);

  const [Section9Array, setSection9Array] = useState([{ name: '', }]);
  const [Section10Array, setSection10Array] = useState([{ name: '', }]);
  const [Section13Array, setSection13Array] = useState([{ name: '', }]);
  const [Section14Array, setSection14Array] = useState([{ name: '', }]);
  const [Section3Array, setSection3Array] = useState([{ name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', },]);

  const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);

  const [inspectionsSection, setInspectionsSection] = useState([{ title: 'A' }]);


  const getTitleForInspectionsSection = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];



  const handleAddInspectionsSection = (index) => {
    setInspectionsSection([...inspectionsSection, { title: '', }]);

    // getSectionToFormList
    formik.values.inspectionsSection.push(PMTemplate.getSectionToFormList(getTitleForInspectionsSection[index]));
  };
  const handleDeleteInputForInspectionsSection = (index) => {
    setInspectionsSection([...inspectionsSection, { title: '', }]);
    const newArray = [...inspectionsSection];
    formik.values.inspectionsSection.splice(index, 1);

    newArray.splice(index, 1);
    setInspectionsSection(newArray);
  };

  const adjustTextareaHeight = (textarea) => {
    textarea.style.height = 'auto'; // Reset the height
    textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
  };

  const expandAllTextareas = () => {
    elementRefs.forEach(ref => {
      if (ref.current) {
        const textareas = ref.current.querySelectorAll('textarea');
        textareas.forEach(adjustTextareaHeight);
      }
    });
  };

  //* -----------For Shedule Milestone---------------
  const [scheduleMilestonesSection, setScheduleMilestonesSection] = useState([{ title: 'A' }]);


  const handleAddScheduleMilestonesSection = (index) => {
    setScheduleMilestonesSection([...scheduleMilestonesSection, { title: '', }]);
    formik.values.scheduleMilestonesSectionList.push(PMTemplate.getScheduleMilestonesSection(getTitleForInspectionsSection[index]));
  };

  const handleDeleteInputForScheduleMilestonesSection = (index) => {
    setScheduleMilestonesSection([...scheduleMilestonesSection, { title: '', }]);
    const newArray = [...scheduleMilestonesSection];
    formik.values.scheduleMilestonesSectionList.splice(index, 1);

    newArray.splice(index, 1);
    setScheduleMilestonesSection(newArray);
  };

  //* ----------------------------------

  const handleAddInputForSection3Array = () => {
    setSection3Array([...Section3Array, { name: '', }]);
    formik.values.section_3.push({ ListAllLIDALabour: '', EstimatedHoursGR: '', EstimatedProjectMonthsInGR: '', ContractBudgetAmount: '', BudgetUsed: '', RemainingBudget: '', ChargeOutRate: '', ProjectedCompletionDate: '', EstimatedHoursToCompletePM: '', EstimatedOfMonthsToCompete: '', ProjectedHoursToComplete: '', ProjectedBudgetToCompete: '', PlusMinusBudget: '', Comments: '', });
  };
  const handleDeleteInputForSection3Array = (index) => {
    setSection3Array([...Section3Array, { name: '', }]);
    const newArray = [...Section3Array];
    formik.values.section_3.splice(index, 1);

    newArray.splice(index, 1);
    setSection3Array(newArray);
  };


  const handleAddInputForSection9Array = () => {
    setSection9Array([...Section9Array, { name: '', }]);
    formik.values.section_9.push({ activitiesworkedOnThisWeek: '', Constractor: '', briefScopeOfWeek: '', sitePrep_Notes_9: '', CurrentForecastedCompletionDate: '', VPConstructionComment: '', });
  };

  const handleDeleteInputForSection9Array = (index) => {
    // Update formik.values.section_9
    const updatedSection9 = [...formik.values.section_9];
    updatedSection9.splice(index, 1);
    formik.setFieldValue('section_9', updatedSection9);

    // Update Section9Array
    const updatedSection9Array = [...Section9Array];
    updatedSection9Array.splice(index, 1);
    setSection9Array(updatedSection9Array);
  };


  const handleAddInputForSection10Array = () => {
    setSection10Array([...Section10Array, { name: '', }]);
    formik.values.section_10.push({ activitiesScheduledOnNextWeek: '', Constractor: '', briefScopeOfWeek: '', sitePrep_Notes_9: '', CurrentForecastedCompletionDate: '', VPConstructionComment: '', });

  };

  const handleDeleteInputForSection10Array = (index) => {
    // Update formik.values.section_10
    const updatedSection10 = [...formik.values.section_10];
    updatedSection10.splice(index, 1);
    formik.setFieldValue('section_10', updatedSection10);

    // Update Section10Array
    const updatedSection10Array = [...Section10Array];
    updatedSection10Array.splice(index, 1);
    setSection10Array(updatedSection10Array);
  };

  const handleAddInputForSection13Array = () => {
    setSection13Array([...Section13Array, { name: '', }]);
    formik.values.section_13.push({ changeWorkOrder: '', date: '', amount: '', approved: '', notes: '', VPCComments: '', });

  };

  const handleDeleteInputForSection13Array = (index) => {
    formik.values.section_13.splice(index, 1);
    setSection13Array([...Section13Array, { name: '', }]);
    const newArray = [...Section13Array];
    newArray.splice(index, 1);
    setSection13Array(newArray);
  };

  const handleAddInputForSection14Array = () => {
    setSection14Array([...Section14Array, { actionItemDiscussed: '', vpConstructionComments: '' }]);
    formik.values.section_14.push({ actionItemDiscussed: '', vpConstructionComments: '' });
  };

  const handleDeleteInputForSection14Array = (index) => {
    formik.values.section_14.splice(index, 1);
    setSection14Array([...Section14Array, { name: '', }]);
    const newArray = [...Section14Array];
    newArray.splice(index, 1);
    setSection14Array(newArray);
  };
  //? ----------------------------------------------------------
  const toast = useRef(null);
  const formik = useFormik({
    initialValues: PMTemplate.getFormName(),
    validate: (data) => {

    },

    onSubmit: (data) => {

      if (!existPageWithoutSave) {
        return;

      }

      data.user_id = localStorage.getItem('user_id');
      data.role_id = localStorage.getItem('role_id');
      var id = editId;
      if (pmId) {
        id = pmId;
      }
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      var url = Api.API_BASE_URL + 'construction/save';


      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          setExistPageWithoutSave(false);
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            setTimeout(function () {
              // navigate('/playbooks')
              // console.log('Testing');
            }, 1000);

            // getUser();
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });


    }
  });

  const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);
  useEffect(() => {



    if (pmId) {
      getTemplateDetails(pmId, 'projectId');
    }

    return () => {

      // formik.handleSubmit();



    };
  }, []);




  const getTemplateDetails = (id, type) => {
    // fetch.

    formik.setFieldValue('projectId', id);
    var _body = {
      projectId: id,
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    var url = Api.API_BASE_URL + 'construction/get';

    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);
        if (response.error != '') {
          formik.setFieldValue('PmTempleteId', 0);
          setInternalJob(response.internal_job);

          formik.setFieldValue('ProjectName', response.EstimatorProjectName);
          formik.setFieldValue('costPerSF', response.costPerSF);
          formik.setFieldValue('costPerSFComments', response.costPerSFComments);
          formik.setFieldValue('costPerSFAmount', response.costPerSFAmount);

          // ----------suraj----------------  

          formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
          formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
          formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
          formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_A_C_Date', response.scheduleProjectCompletion);

          formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
          formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_P_B_C_Date', response.ProjectCompletionDate);
          formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_C_F_C_Date', response.ProjectCompletionDate);
          // formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
          // formik.setFieldValue('sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
          // formik.setFieldValue('sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
          // formik.setFieldValue('sitePrep_A_C_Date', response.scheduleProjectCompletion);

          // formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
          // formik.setFieldValue('turnOver_P_B_C_Date', response.ProjectCompletionDate);
          // formik.setFieldValue('turnOver_C_F_C_Date', response.ProjectCompletionDate);

          PMTemplate.section_4_List().forEach(element => {
            //console.log(response.pm_section_4[element], element)
            formik.setFieldValue(element, response.pm_section_4[element]);
          });

          if(response.ProjectCompletionDate !="0000-00-00" &&  response.ProjectCompletionDate !=null){
            handleDateCalculation(response.ProjectCompletionDate);
          }

        } else {

          setInternalJob(response.internal_job);
          formik.setFieldValue('PmTempleteId', response.pmTemplateId);
          PMTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_1[element]);
          });



          if (response.pm_section_2.length != 0) {
            formik.setFieldValue(`inspectionsSection`, response.pm_section_2);
            setInspectionsSection(response.pm_section_2);
            // console.log('pm_section_2', formik.values.inspectionsSection);


          }

          // PMTemplate.section_2_List().forEach(element => {
          //   formik.setFieldValue(element, response.pm_section_2[element]);
          // });
          // PMTemplate.section_3_List().forEach(element => {
          //   formik.setFieldValue(element, response.pm_section_3[element]);
          // });
          PMTemplate.section_4_List().forEach(element => {
            console.log(response.pm_section_4[element], element)
            formik.setFieldValue(element, response.pm_section_4[element]);
          });
          PMTemplate.section_5_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_5[element]);
          });
          if (response.pm_section_6.length != 0) {
            formik.setFieldValue(`section_6`, response.pm_section_6);
          }
          if (response.pm_section_3_new.length != 0) {
            formik.setFieldValue(`section_3`, response.pm_section_3_new);
            setSection3Array(response.pm_section_3_new);
          }
          PMTemplate.section_7_List().forEach(element => {

            formik.setFieldValue(element, response.pm_section_7[element]);

           // console.log(formik.values[element])
          });



          // PMTemplate.section_8_List().forEach(element => {
          //   formik.setFieldValue(element, response.pm_section_8[element]);
          // });
          if (response.pm_section_8.length != 0) {
            formik.setFieldValue(`scheduleMilestonesSectionList`, response.pm_section_8);
            setScheduleMilestonesSection(response.pm_section_8);
            // console.log('pm_section_2', formik.values.inspectionsSection);


          }


          formik.setFieldValue(`section_9`, response.pm_section_9);
          setSection9Array(response.pm_section_9);
          formik.setFieldValue(`section_10`, response.pm_section_10);
          setSection10Array(response.pm_section_10);
          PMTemplate.section_11_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_11[element]);
          });
          PMTemplate.section_12_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_12[element]);
          });



          formik.setFieldValue(`section_13`, response.pm_section_13);
          setSection13Array(response.pm_section_13);
          formik.setFieldValue(`section_14`, response.pm_section_14);
          setSection14Array(response.pm_section_14);
          PMTemplate.section_15_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_15[element]);
          });
          PMTemplate.section_16_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_16[element]);
          });
          PMTemplate.section_17_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_17[element]);
          });
          PMTemplate.section_18_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_18[element]);
          });
          //console.log('response.scheduleProjectCompletion', response.scheduleProjectCompletion);

          if (response.pm_section_7.scheduleConstructionStartDate == '0000-00-00') {

           // console.log('response.scheduleProjectCompletion', response.scheduleProjectCompletion);
            formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
            formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
            formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
            formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_A_C_Date', response.scheduleProjectCompletion);
          }

          if (response.pm_section_7.scheduleProjectCompletion == '0000-00-00') {
            formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
            formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_P_B_C_Date', response.ProjectCompletionDate);
            formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_C_F_C_Date', response.ProjectCompletionDate);
          }

          if(response.pm_section_8[0].finalInvoice_C_F_C_Date=="0000-00-00" || response.pm_section_8[0].finalInvoice_C_F_C_Date ==null){
            if(response.ProjectCompletionDate!="0000-00-00" &&  response.ProjectCompletionDate !=null){
              handleDateCalculation(response.ProjectCompletionDate);
            }
           
          }

        }

        setIsLoading(false);

      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }

  const getProjectDetails = () => {
    // fetch.
    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    var _body = {
      userId: user_id,
      role_id: role_id,
    }
    fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
      method: "POST",

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);
        setProjectData(response.result);

      })
      .catch((error) => {
        // setIsLoading(false);
        console.error("Error:", error);
      });
  }

  //? -----------------------
  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // backgroundColor:'white'
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'
  };

  const borderStyle = {

  };

  const yesCellStyle = {
    ...cellStyle,
  };

  const firstColumnWidth = {
    width: "80px",
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
  };

  //? -----------------------

  const handleDateCalculation = (inputDate) => {
    // Step 1: Parse the input date in YYYY-MM-DD format
    const [year, month, day] = inputDate.split('-').map(Number); // Ensure proper numeric parsing
    const initialDate = new Date(year, month - 1, day); // Create a valid Date object

    if (isNaN(initialDate.getTime())) {
        console.error("Invalid initialDate:", initialDate);
        return "Invalid date format. Please use YYYY-MM-DD.";
    }
    const year1 = newDate.getFullYear();
    if (year1 < 2005) {
      return ; 
    }
    // Step 2: Add 30 days
    let newDate = new Date(initialDate);
    newDate.setDate(newDate.getDate() + 30);

    let formattedDate = newDate.toISOString().split('T')[0];
  
   let re =  formattedDate.split('-');
   console.log(re)
   if(re[1] == '02'){
  
      

      // Create a date for March 1st of the current year
      let marchFirst = new Date(re[0], 2, 1); // Month is 0-based (0 is January, 2 is March)

      // Subtract one day to get the last day of February
      let lastDayOfFeb = new Date(marchFirst - 1);

      // Get the day part of the date (last day of February)
      let lastDay = lastDayOfFeb.getDate();
       let days = `${re[0]}-${re[1]}-${lastDay}`

      formik.setFieldValue('scheduleMilestonesSectionList.0.finalInvoice_C_F_C_Date',days);
   }else{
    let days = `${re[0]}-${re[1]}-30`
    formik.setFieldValue('scheduleMilestonesSectionList.0.finalInvoice_C_F_C_Date',days);
   }
   
    return;

    
   // return outputDateFormatted;
};


  const renderTextArea = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      value={formData != '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log('e.target.value', fieldName);
        console.log('e.target.value', e.target.value);

        setExistPageWithoutSave(true);

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
    >{formData}</textarea>
  );


  const renderTextAreaFull = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      autoResize
      id={fieldName}
      rows={maxLine}
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        // console.log(e.target.value)
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
    ></InputTextarea>
  );

  const renderTextAreaFullCostPerSF = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      disabled
      autoResize
      id={fieldName}
      rows={maxLine}
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        // console.log(e.target.value)
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
    ></InputTextarea>
  );

  const renderTextAreadis = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      disabled
      value={formData != '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log('e.target.value', fieldName);
        console.log('e.target.value', e.target.value);

        setExistPageWithoutSave(true);

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
    >{formData}</textarea>
  );


  const renderInputArea = (fieldName, placeholder, type = 'text', fromData = '') => {
    if (type == 'date') {

      if (fromData != null) {
        let timestamp = new Date(fromData);



        if (!isNaN(timestamp.getTime())) {
          fromData = timestamp.toISOString().split('T')[0];
        }
      }
    }

    // Define the background color based on the field name
    let backgroundColor = '';
    if (fieldName === 'scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date') {
      backgroundColor = '#FFE1FF';
    } else if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_C_F_C_Date') {
      backgroundColor = '#FFCFB3';
    } else if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_P_B_C_Date') {
      backgroundColor = '#FFEB55';
    } else if (fieldName === 'scheduleMilestonesSectionList.0.Completion_C_F_C_Date') {
      backgroundColor = '#96CEB4';
    }
    else if (fieldName === 'scheduleMilestonesSectionList.0.finalInvoice_C_F_C_Date') {
      backgroundColor = '#e9c6ff';
    }


    return (
      <input
        type={type}
        placeholder={placeholder}
        name={fieldName}
        id={fieldName}
        value={fromData != '' ? fromData : formik.values[fieldName]}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);

          if (fieldName === 'scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date') {
            formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
          }
          if (internalJob == 'Y') {
            if (fieldName === 'scheduleMilestonesSectionList.0.Completion_C_F_C_Date') {
              formik.setFieldValue('scheduleProjectCompletion', e.target.value);
              handleDateCalculation(e.target.value)
            }
          } else {
            if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_C_F_C_Date') {
              formik.setFieldValue('scheduleProjectCompletion', e.target.value);
              handleDateCalculation(e.target.value)
            }
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        style={{
          width: '100%',
          height: '40px',
          boxSizing: 'border-box',
          border: 'none',
          textAlign: 'center',
          marginTop: '0px',
          backgroundColor: backgroundColor
        }}
      />
    )
  };

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
      }}
    />
  );

  const renderInputAreaForCostPerSF = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center select-disabled2"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      disabled

      // onChange={(e) => {
      //   setExistPageWithoutSave(true);
      //   formik.setFieldValue(fieldName, e.value)
      // }}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
        color: "black",
      }}
    />
  );


  const renderInputAreaForHour = (fieldName, formData = '') => (
    <InputNumber
      inputClassName="is-positive"
      value={formData != '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center",
        marginTop: "0px",
      }}
    />
  );

  const renderPercentageInputArea = (fieldName, formData = '') => (
    <InputNumber

      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
      placeholder="0.00"
      maxFractionDigits={2}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      suffix="%"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  //! ----------------------------------------------------------


  const renderSelect = (fieldName, formData = '') => (
    <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      className={'select-text-color-' + formik.values[fieldName]}
      onChange={(e) => {

        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
      <option value="NO">No</option>
      <option value="YES">Yes</option>
      <option value="NA">N/A</option>

    </select>
  );

  const renderSelectN = (fieldName, formData = '') => {
    // Get the initial value from formData or formik
    var val = (formData !== '') ? formData : formik.values[fieldName];

    return (
      <select
        name={fieldName}
        id={fieldName}
        value={val}
        className={'select-text-color-' + (val === 'YES' ? 'NO' : val === 'NO' ? 'YES' : 'NA')}  // Change class based on selection
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{
          width: '100%',
          textAlign: 'center',

          color: 'white',
          backgroundColor: '#ff0000',
          border: 'none',
        }}
      >
        <option value="NO">No</option>
        <option value="YES">Yes</option>
        <option value="NA">N/A</option>
      </select>
    );
  };



  const renderSelect1 = (fieldName, formData = '') => {

    var val = (formData != '') ? formData : formik.values[fieldName];


    return <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      className={'select-text-color-' + val}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
      <option value="NO">No</option>
      <option value="YES">Yes</option>
    </select>
  };

  const renderSelect1N = (fieldName, formData = '') => {

    // Get the initial value from formData or formik
    var val = (formData !== '') ? formData : formik.values[fieldName];

    return (
      <select
        name={fieldName}
        id={fieldName}
        value={val}
        className={'select-text-color-' + (val === 'YES' ? 'NO' : 'YES')}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{
          width: '100%',
          textAlign: 'center',

          color: 'white',
          backgroundColor: '#ff0000',
          border: 'none',
        }}
      >
        <option value="NO">No</option>
        <option value="YES">Yes</option>
      </select>
    );
  };




  const renderSelectForSection5 = (fieldName, placeholder, options, formData = '') => (
    <select
      name={fieldName}
      id={fieldName}
      disabled
      value={(formData != '') ? formData : formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', border: 'none' }}>
      {options.map((option) => (
        <option value={option.id}>{option.name}</option>
      ))}

    </select>
  );

  const renderSelectForCostPerSF = (fieldName) => (
    <select
      name={fieldName}
      id={fieldName}
      value={formik.values[fieldName]}
      className="select-disabled"
      disabled
      // onChange={(e) => {
      //   setExistPageWithoutSave(true);
      //   formik.setFieldValue(fieldName, e.target.value);
      // }}
      style={{
        width: '100%',
        textAlign: 'center',

        height: '32px',
        borderRight: 'none',
      }}
    >
      <option value="Custom Home with Basement">Custom Home with Basement</option>
      <option value="Custom Home Slab on Grade">Custom Home Slab on Grade</option>
      <option value="Custom Home Crawl">Custom Home Crawl</option>
      <option value="Town House">Town House</option>
      <option value="Condo Above Ground">Condo Above Ground</option>
      <option value="Condo 1 Level Underground">Condo 1 Level Underground</option>
      <option value="Addition">Addition</option>
      <option value="Whole home gut">Whole home gut</option>
      <option value="Tenent Improvement">Tenent Improvement</option>
      <option value="Commerical Build">Commerical Build</option>
      <option value="Renovation">Renovation</option>
    </select>
  );


  const priceBodyTemplatee = (rowData) => {
    if (rowData === '') {
      return '';
    }
    let numberValue = Number(rowData);
    // Ensure rowData is a number after the conversion and it's not NaN
    if (isNaN(numberValue)) {

      return '';
    }

    const isNegative = rowData < 0; // Check if the value is negative

    return <span style={{ color: isNegative ? "red" : "black" }}>
      {formatCurrency(rowData)}

    </span>
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };


  const section_1_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, placeholder) => {
    console.log('fieldName_1:', fieldName_1);
    console.log('fieldName_2:', fieldName_2);
    console.log('fieldName_3:', fieldName_3);
    console.log('fieldName_4:', fieldName_4);

    return (
      <tr style={{}}>
        <td style={{ ...cellStyle, ...firstColumnWidth }} >
          {title}
        </td>

        <td style={{ borderStyle, cellStyleW, backgroundColor: 'white' }}>
          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
            {/* {renderSelect1(fieldName_1)} */}
            {
              (fieldName_1 === 'anyErrorAndDeficiencies_PM' || fieldName_1 === 'riskSafetyClientTeam_PM')
                ? renderSelect1N(fieldName_1)
                : renderSelect1(fieldName_1)
            }
          </td>
          <td style={{ ...cellStyleW, width: '100%' }}>
            {renderTextAreaFull(fieldName_2, placeholder)}
          </td>
        </td>

        <td style={{ borderStyle, cellStyleW, backgroundColor: 'white' }}>
          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
            {/* {renderSelect(fieldName_3)} */}
            {
              (fieldName_3 === 'anyErrorAndDeficiencies_VPC' || fieldName_3 === 'riskSafetyClientTeam_VPC')
                ? renderSelectN(fieldName_3)
                : renderSelect(fieldName_3)
            }
          </td>
          <td style={{ ...cellStyleW, width: '100%' }}>
            {renderTextAreaFull(fieldName_4, placeholder)}
          </td>
        </td>

      </tr>
    );
  }

  const renderSelectForSection2 = (fieldName, formData = '') => (
    <select
      name={fieldName}
      id={fieldName}
      value={(formData != '') ? formData : formik.values[fieldName]}
      className={'select-text-color-' + formData}
      onChange={(e) => {

        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
      <option value="NO">No</option>
      <option value="YES">Yes</option>
      <option value="NA">N/A</option>

    </select>
  );
  const section_2_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5, fieldName_6, formData_1, formData_2, formData_3, formData_4, formData_5, formData_6) => {
    return (<tr>
      <td style={cellStyle}>{title}</td>
      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelectForSection2(fieldName_1, formData_1)}
      </td>

      <td style={cellStyleW}>
        {renderInputArea(fieldName_2, '', 'date', formData_2)}
      </td>

      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelectForSection2(fieldName_3, formData_3)}
      </td>

      <td style={cellStyleW}>
        {renderTextAreaFull(fieldName_4, '', formData_4)}
      </td>

      <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
        {renderSelectForSection2(fieldName_5, formData_5)}
      </td>

      <td style={cellStyleW}>
        {renderTextAreaFull(fieldName_6, '', formData_6)}
      </td>

    </tr>
    );
  }



  const section_5_Body = (title, title2, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={{ ...cellStyleW, }}>{renderInputAreaForAmount(fieldName_1)}</td>
        <td style={cellStyleW}>{renderInputAreaForAmount(fieldName_2)}</td>
        <td style={{ ...cellStyle, textAlign: 'center' }}>
          {priceBodyTemplatee(formik.values[fieldName_1] - formik.values[fieldName_2])}
        </td>
        <td style={cellStyleW}>  {renderTextAreaFull(fieldName_5, '')}	</td>
        <td style={cellStyleW}>
          {renderTextAreaFull(fieldName_4, '')}
        </td>

      </tr>
    );

  }

  const section_8_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5, FormName_1, FormName_2, FormName_3, FormName_4, FormName_5) => {

    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_1, '', 'date', FormName_1)}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_2, '', 'date', FormName_2)}</td>
        <td style={cellStyleW}>{renderInputArea(fieldName_3, '', 'date', FormName_3)}</td>

        <td style={cellStyleW}>
          {renderTextAreaFull(fieldName_4, '', FormName_4)}
        </td>

      </tr>
    );

  }

  const section_11_Body = (title, fieldName_1, fieldName_2) => {
    return (
      <tr>
        <td style={cellStyle}>{title}</td>
        <td style={{ ...cellStyle, textAlign: 'center', }}>{fieldName_1 == "jobRunningTotal" ? getJobRunningTotal() : fieldName_1 == "balance" ? getBalaceTotal() : renderInputAreaForAmount(fieldName_1)}</td>

      </tr>

    );
  }

  const getBalaceTotal = () => {

    var nettotal = Number(formik.values.contractPriceAmount) + Number(formik.values.approvedChangeOrderPrice) + Number(formik.values.allowanceDiffrence);
    var total = nettotal + Number(formik.values.gst) - Number(formik.values.amountPaid);

    var formattedTotal2 = total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    //formik.setFieldValue('jobRunningTotal', total);
    return <div style={{ minHeight: '35px', paddingTop: '8px' }}><strong>{formattedTotal2}</strong></div>;
  }
  const getJobRunningTotal = () => {

    var total = Number(formik.values.contractPriceAmount) + Number(formik.values.approvedChangeOrderPrice) + Number(formik.values.allowanceDiffrence);

    var formattedTotal = total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    //formik.setFieldValue('jobRunningTotal', total);
    return <div style={{ minHeight: '35px', paddingTop: '8px' }}><strong>{formattedTotal}</strong></div>;

  }

  //* -------------------------
  const copyImageToClipboard = (blob) => {
    // Check if Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.write) {
      navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
        console.log('Image copied to clipboard');
      }).catch((error) => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
        console.error('Error copying image to clipboard:', error);
      });
    } else {
      setIsCopyBtnLoading(false);
      console.error('Clipboard API not available,', navigator.clipboard);
    }
  };

  const elementRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    // Add more refs for additional elements as needed
  ];


  const takeScreenshotAndCopy = async () => {
    setIsCopyBtnLoading(true);
    console.log('Take screenshot and copy to clipboard');

    try {
      // Expand all textareas to fit their content
      expandAllTextareas();

      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await toPng(ref.current, {
            cacheBust: true,
            pixelRatio: 2,
          });
        }
        return null;
      });

      const images = await Promise.all(canvasPromises);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      const context = combinedCanvas.getContext('2d');

      // Calculate total height of combined screenshots
      let totalHeight = 0;
      let maxWidth = 0;
      for (const imgSrc of images) {
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            totalHeight += img.height;
            if (img.width > maxWidth) maxWidth = img.width;
            resolve();
          };
        });
      }

      combinedCanvas.width = maxWidth;
      combinedCanvas.height = totalHeight;

      let offsetY = 0;
      for (const imgSrc of images) {
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            context.drawImage(img, 0, offsetY);
            offsetY += img.height;
            resolve();
          };
        });
      }

      // Convert the combined canvas to a data URL
      combinedCanvas.toBlob(blob => {
        if (blob) {
          copyImageToClipboard(blob);
        } else {
          console.error('Error creating blob');
        }
      }, 'image/png');

    } catch (error) {
      setIsCopyBtnLoading(false);
      console.error('Error taking screenshots:', error);
    }
  };

  //* -------------------------



  return (
    <>
      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (


        <form onSubmit={formik.handleSubmit} className="pm-template-form">
          <div className="flex justify-content-end submitbutton top-button" >
            <Button className="m-2 mx-4 p-2 px-3 copySave-button" loading={isCopyBtnLoading} type="button" title="Copy Client Weekly Update" onClick={takeScreenshotAndCopy}>
              <strong className="mr-2">Copy weekly update</strong>
              <FaCopy />
            </Button>

            <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center customSave-button" type="submit">
              <strong className="mr-2">Save</strong>
              <i className="pi pi-save"></i>
            </Button>

          </div>



          <div className="cardd" style={{ border: 'none', }} >
            {/* <Accordion multiple activeIndex={[]} > */}
            <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]} >

              {/* Section 1 */}

              <AccordionTab header="ACTION STEPS" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto", }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }} >
                          Action Steps
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          PM Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments Only
                        </th>
                      </tr>
                    </thead>

                    <tbody>


                      <tr>
                        <td style={cellStyle} >
                          Target GP% CH 20% Reno 30%
                        </td>
                        <td style={cellStyleW} >
                          {renderTextAreaFull('targetGp', '')}
                        </td>
                        <td style={cellStyleW} >
                          {renderTextAreaFull('targetGpVpComments', '')}
                        </td>
                      </tr>

                      <tr>
                        <td style={cellStyle} >
                          Percentage Completion?
                        </td>
                        <td style={cellStyleW} >
                          {renderTextAreaFull('percentageCompletion', '')}
                        </td>
                        <td style={cellStyleW} > {renderTextAreaFull('percentageCompletionGpVpComments', '')}</td>
                      </tr>

                      <tr>
                        <td style={{ ...cellStyle, alignItems: 'center' }} >
                          <div style={{ ...cellStyle, border: 'none', display: 'flex' }}>
                            <span style={{ flex: '0 0 auto', paddingTop: '6px' }}>Cost Per SF</span>
                            <div style={{ flex: '1', marginLeft: '45px', width: '50%' }}>
                              {renderSelectForCostPerSF('costPerSF')}
                            </div>
                          </div>

                        </td>
                        <td style={{ ...cellStyleW, display: 'flex', alignItems: 'center' }} >


                          <div style={{ flex: '0 0 35%', borderRight: '2px solid #DDDFE2', }}>
                            {/* {renderInputAreaForAmount('costPerSFAmount')} */}
                            {renderInputAreaForCostPerSF('costPerSFAmount')}
                          </div>
                          <div style={{ flex: '0 0 65%', paddingTop: '5px', paddingLeft: '10px' }}>
                            {/* {renderTextAreaFull('costPerSFComments', 'comments')} */}
                            {renderTextAreaFullCostPerSF('costPerSFComments', 'comments')}
                          </div>
                        </td>
                        <td style={cellStyleW} >
                          {renderTextAreaFull('costPerSFVpComments', '',)}
                          {/* {renderTextAreaFullCostPerSF('costPerSFVpComments', '',)} */}
                        </td>
                      </tr>
                      {section_1_Body('Proj. on Schedule?', 'projectOnSchedule_PM', 'projectOnSchedule_PMReason', 'projectOnSchedule_VPC', 'projectOnSchedule_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('Trade partners advised of schedule 2M, 1M, 1W, 3D, 1D before they/material required on site?', 'tradePartnerAdvised_PM', 'tradePartnerAdvised_PMReason', 'tradePartnerAdvised_VPC', 'tradePartnerAdvised_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('All City and Engineering Inspections Completed and uploaded to BT?', 'allCityAndEngineersInspection_PM', 'allCityAndEngineersInspection_PMReason', 'allCityAndEngineersInspection_VPC', 'allCityAndEngineersInspection_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Proj. on budget?', 'projectOnBudget_PM', 'projectOnBudget_PMReason', 'projectOnBudget_VPC', 'projectOnBudget_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Proj. baseline set at excavation and project meeting baseline?', 'projectBaseLineSetExecution_PM', 'projectBaseLineSetExecution_PMReason', 'projectBaseLineSetExecution_VPC', 'projectBaseLineSetExecution_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('Any Errors & Deficiencies?', 'anyErrorAndDeficiencies_PM', 'anyErrorAndDeficiencies_PMReason', 'anyErrorAndDeficiencies_VPC', 'anyErrorAndDeficiencies_VPCReason', 'Reason? (If no) ')}

                      {section_1_Body('Labour in BT consistent with % of project completion', 'LidaLabourInBTConsistent_PM', 'LidaLabourInBTConsistent_PMReason', 'LidaLabourInBTConsistent_VPC', 'LidaLabourInBTConsistent_VPCReason', 'Reason? (If Yes)')}


                      {section_1_Body('PM Contractor & Material BT TODO\'s upto date?', 'pmContructorAndMaterialBT_PM', 'pmContructorAndMaterialBT_PMReason', 'pmContructorAndMaterialBT_VPC', 'pmContructorAndMaterialBT_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Weekly PM/Client Update done?', 'weeklyPMClientUpdateDone_PM', 'weeklyPMClientUpdateDone_PMReason', 'weeklyPMClientUpdateDone_VPC', 'weeklyPMClientUpdateDone_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Have all Trade/Materials been inspected for QA & against the plans, specs, & drawings', 'haveAllTradeMaterialBeenInspected_PM', 'haveAllTradeMaterialBeenInspected_PMReason', 'haveAllTradeMaterialBeenInspected_VPC', 'haveAllTradeMaterialBeenInspected_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('PM QC BT TODO\'s Upto date?', 'pmQCVTTodoUptoDate_PM', 'pmQCVTTodoUptoDate_PMReason', 'pmQCVTTodoUptoDate_VPC', 'pmQCVTTodoUptoDate_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('PO/Sub Agreements upto date?', 'poSubAggreementUptoDate_PM', 'poSubAggreementUptoDate_PMReason', 'poSubAggreementUptoDate_VPC', 'poSubAggreementUptoDate_VPCReason', 'Reason? (If no)')}


                      {section_1_Body('Is client happy?', 'isClientHappy_PM', 'isClientHappy_PMReason', 'isClientHappy_VPC', 'isClientHappy_VPCReason', 'Reason? (If no)')}

                      {section_1_Body('Risk/Safety/Client/Team?', 'riskSafetyClientTeam_PM', 'riskSafetyClientTeam_PMReason', 'riskSafetyClientTeam_VPC', 'riskSafetyClientTeam_VPCReason', 'Reason? (If no)')}


                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              {/* Section 2 */}

              {inspectionsSection.map((item, index) => (
                <AccordionTab header={
                  <div className="flex justify-between items-center w-full accodianBtn" >

                    <span className="font-bold white-space-nowrap ">INSPECTIONS REQUIRED {getTitleForInspectionsSection[index]}</span>

                    <div className="flex items-center space-x-2">
                      {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForInspectionsSection(index)} />) : null}

                      {inspectionsSection.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInspectionsSection(index)} />) : null}
                    </div>
                  </div>
                }
                  className="mt-2" headerIcon="pi pi-plus">
                  <div className="table-container" style={{ overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", }}>
                      <thead>
                        <tr>
                          <th style={{ ...headerStyle, width: "400px" }}>
                            Inspections Required
                          </th>
                          <th style={{ ...headerStyle, width: "100px" }}>
                            Done: Yes/No or N/A
                          </th>
                          <th style={{ ...headerStyle, minWidth: "100px" }}>
                            Date Approved
                          </th>
                          <th style={{ ...headerStyle, width: "100px" }}>
                            Uploaded to BT: Yes/No or N/A
                          </th>
                          <th style={{ ...headerStyle, minWidth: "250px" }}>
                            PM Comments
                          </th>
                          <th style={{ ...headerStyle, width: "100px" }}>
                            Uploaded to BT: Yes/No or N/A
                          </th>
                          <th style={{ ...headerStyle, minWidth: "500px" }}>
                            Vp Construction Ops Comments Only
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {section_2_Body(`Geo Tech inspection`, `inspectionsSection.${index}.geoTechInspectionDone`, `inspectionsSection.${index}.geoTechInspectionDateApproved`, `inspectionsSection.${index}.geoTechInspectionUploadedToBT_1`, `inspectionsSection.${index}.geoTechInspectionPMCommnets`, `inspectionsSection.${index}.geoTechInspectionUploadedToBT_2`, `inspectionsSection.${index}.geoTechInspection_VPcommercial`, formik.values.inspectionsSection[index].geoTechInspectionDone, formik.values.inspectionsSection[index].geoTechInspectionDateApproved, formik.values.inspectionsSection[index].geoTechInspectionUploadedToBT_1, formik.values.inspectionsSection[index].geoTechInspectionPMCommnets, formik.values.inspectionsSection[index].geoTechInspectionUploadedToBT_2, formik.values.inspectionsSection[index].geoTechInspection_VPcommercial,)}

                        {section_2_Body(`City ground inspection`, `inspectionsSection.${index}.cityGroundInspectionDone`, `inspectionsSection.${index}.cityGroundInspectionDateApproved`, `inspectionsSection.${index}.cityGroundInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityGroundInspectionPMCommnets`, `inspectionsSection.${index}.cityGroundInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityGroundInspection_VPcommercial`, formik.values.inspectionsSection[index].cityGroundInspectionDone, formik.values.inspectionsSection[index].cityGroundInspectionDateApproved, formik.values.inspectionsSection[index].cityGroundInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityGroundInspectionPMCommnets, formik.values.inspectionsSection[index].cityGroundInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityGroundInspection_VPcommercial,)}

                        {section_2_Body(`Engineer footing inspection`, `inspectionsSection.${index}.engineerFootingInspectionDone`, `inspectionsSection.${index}.engineerFootingInspectionDateApproved`, `inspectionsSection.${index}.engineerFootingInspectionUploadedToBT_1`, `inspectionsSection.${index}.engineerFootingInspectionPMCommnets`, `inspectionsSection.${index}.engineerFootingInspectionUploadedToBT_2`, `inspectionsSection.${index}.engineerFootingInspection_VPcommercial`, formik.values.inspectionsSection[index].engineerFootingInspectionDone, formik.values.inspectionsSection[index].engineerFootingInspectionDateApproved, formik.values.inspectionsSection[index].engineerFootingInspectionUploadedToBT_1, formik.values.inspectionsSection[index].engineerFootingInspectionPMCommnets, formik.values.inspectionsSection[index].engineerFootingInspectionUploadedToBT_2, formik.values.inspectionsSection[index].engineerFootingInspection_VPcommercial,)}

                        {section_2_Body(`City footing inspection`, `inspectionsSection.${index}.cityFootingInspectionDone`, `inspectionsSection.${index}.cityFootingInspectionDateApproved`, `inspectionsSection.${index}.cityFootingInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityFootingInspectionPMCommnets`, `inspectionsSection.${index}.cityFootingInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityFootingInspection_VPcommercial`, formik.values.inspectionsSection[index].cityFootingInspectionDone, formik.values.inspectionsSection[index].cityFootingInspectionDateApproved, formik.values.inspectionsSection[index].cityFootingInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityFootingInspectionPMCommnets, formik.values.inspectionsSection[index].cityFootingInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityFootingInspection_VPcommercial,)}

                        {section_2_Body(`Engineering wall inspection`, `inspectionsSection.${index}.engineeringWallInspectionDone`, `inspectionsSection.${index}.engineeringWallInspectionDateApproved`, `inspectionsSection.${index}.engineeringWallInspectionUploadedToBT_1`, `inspectionsSection.${index}.engineeringWallInspectionPMCommnets`, `inspectionsSection.${index}.engineeringWallInspectionUploadedToBT_2`, `inspectionsSection.${index}.engineeringWallInspection_VPcommercial`, formik.values.inspectionsSection[index].engineeringWallInspectionDone, formik.values.inspectionsSection[index].engineeringWallInspectionDateApproved, formik.values.inspectionsSection[index].engineeringWallInspectionUploadedToBT_1, formik.values.inspectionsSection[index].engineeringWallInspectionPMCommnets, formik.values.inspectionsSection[index].engineeringWallInspectionUploadedToBT_2, formik.values.inspectionsSection[index].engineeringWallInspection_VPcommercial,)}


                        {section_2_Body(`City Wall inspection`, `inspectionsSection.${index}.cityWallInspectionDone`, `inspectionsSection.${index}.cityWallInspectionDateApproved`, `inspectionsSection.${index}.cityWallInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityWallInspectionPMCommnets`, `inspectionsSection.${index}.cityWallInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityWallInspection_VPcommercial`, formik.values.inspectionsSection[index].cityWallInspectionDone, formik.values.inspectionsSection[index].cityWallInspectionDateApproved, formik.values.inspectionsSection[index].cityWallInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityWallInspectionPMCommnets, formik.values.inspectionsSection[index].cityWallInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityWallInspection_VPcommercial,)}

                        {section_2_Body(`City storm drain/RWL inspection`, `inspectionsSection.${index}.cityStormDrainRWLinspectionDone`, `inspectionsSection.${index}.cityStormDrainRWLinspectionDateApproved`, `inspectionsSection.${index}.cityStormDrainRWLinspectionUploadedToBT_1`, `inspectionsSection.${index}.cityStormDrainRWLinspectionPMCommnets`, `inspectionsSection.${index}.cityStormDrainRWLinspectionUploadedToBT_2`, `inspectionsSection.${index}.cityStormDrainRWLinspection_VPcommercial`, formik.values.inspectionsSection[index].cityStormDrainRWLinspectionDone, formik.values.inspectionsSection[index].cityStormDrainRWLinspectionDateApproved, formik.values.inspectionsSection[index].cityStormDrainRWLinspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityStormDrainRWLinspectionPMCommnets, formik.values.inspectionsSection[index].cityStormDrainRWLinspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityStormDrainRWLinspection_VPcommercial,)}

                        {section_2_Body(`City sewer connection inspection`, `inspectionsSection.${index}.citySewerConnectionInspectionDone`, `inspectionsSection.${index}.citySewerConnectionInspectionDateApproved`, `inspectionsSection.${index}.citySewerConnectionInspectionUploadedToBT_1`, `inspectionsSection.${index}.citySewerConnectionInspectionPMCommnets`, `inspectionsSection.${index}.citySewerConnectionInspectionUploadedToBT_2`, `inspectionsSection.${index}.citySewerConnectionInspection_VPcommercial`, formik.values.inspectionsSection[index].citySewerConnectionInspectionDone, formik.values.inspectionsSection[index].citySewerConnectionInspectionDateApproved, formik.values.inspectionsSection[index].citySewerConnectionInspectionUploadedToBT_1, formik.values.inspectionsSection[index].citySewerConnectionInspectionPMCommnets, formik.values.inspectionsSection[index].citySewerConnectionInspectionUploadedToBT_2, formik.values.inspectionsSection[index].citySewerConnectionInspection_VPcommercial,)}

                        {section_2_Body(`City plumbing ground rough in inspection`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspectionDone`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspectionDateApproved`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspectionUploadedToBT_1`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspectionPMCommnets`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspectionUploadedToBT_2`, `inspectionsSection.${index}.cityPlumbingGroundRoughIninspection_VPcommercial`, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspectionDone, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspectionDateApproved, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspectionPMCommnets, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityPlumbingGroundRoughIninspection_VPcommercial,)}

                        {section_2_Body(`City ground seal inspection`, `inspectionsSection.${index}.cityGroundSealInspectionDone`, `inspectionsSection.${index}.cityGroundSealInspectionDateApproved`, `inspectionsSection.${index}.cityGroundSealInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityGroundSealInspectionPMCommnets`, `inspectionsSection.${index}.cityGroundSealInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityGroundSealInspection_VPcommercial`, formik.values.inspectionsSection[index].cityGroundSealInspectionDone, formik.values.inspectionsSection[index].cityGroundSealInspectionDateApproved, formik.values.inspectionsSection[index].cityGroundSealInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityGroundSealInspectionPMCommnets, formik.values.inspectionsSection[index].cityGroundSealInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityGroundSealInspection_VPcommercial,)}

                        {section_2_Body(`Engineering framing inspection`, `inspectionsSection.${index}.engineeringFramingInspectionDone`, `inspectionsSection.${index}.engineeringFramingInspectionDateApproved`, `inspectionsSection.${index}.engineeringFramingInspectionUploadedToBT_1`, `inspectionsSection.${index}.engineeringFramingInspectionPMCommnets`, `inspectionsSection.${index}.engineeringFramingInspectionUploadedToBT_2`, `inspectionsSection.${index}.engineeringFramingInspection_VPcommercial`, formik.values.inspectionsSection[index].engineeringFramingInspectionDone, formik.values.inspectionsSection[index].engineeringFramingInspectionDateApproved, formik.values.inspectionsSection[index].engineeringFramingInspectionUploadedToBT_1, formik.values.inspectionsSection[index].engineeringFramingInspectionPMCommnets, formik.values.inspectionsSection[index].engineeringFramingInspectionUploadedToBT_2, formik.values.inspectionsSection[index].engineeringFramingInspection_VPcommercial,)}

                        {section_2_Body(`Vent checklist submitted`, `inspectionsSection.${index}.ventChecklistSubmittedDone`, `inspectionsSection.${index}.ventChecklistSubmittedDateApproved`, `inspectionsSection.${index}.ventChecklistSubmittedUploadedToBT_1`, `inspectionsSection.${index}.ventChecklistSubmittedPMCommnets`, `inspectionsSection.${index}.ventChecklistSubmittedUploadedToBT_2`, `inspectionsSection.${index}.ventChecklistSubmitted_VPcommercial`, formik.values.inspectionsSection[index].ventChecklistSubmittedDone, formik.values.inspectionsSection[index].ventChecklistSubmittedDateApproved, formik.values.inspectionsSection[index].ventChecklistSubmittedUploadedToBT_1, formik.values.inspectionsSection[index].ventChecklistSubmittedPMCommnets, formik.values.inspectionsSection[index].ventChecklistSubmittedUploadedToBT_2, formik.values.inspectionsSection[index].ventChecklistSubmitted_VPcommercial,)}

                        {section_2_Body(`Heat/Loss calculation report`, `inspectionsSection.${index}.heatLossCalReportDone`, `inspectionsSection.${index}.heatLossCalReportDateApproved`, `inspectionsSection.${index}.heatLossCalReportUploadedToBT_1`, `inspectionsSection.${index}.heatLossCalReportPMCommnets`, `inspectionsSection.${index}.heatLossCalReportUploadedToBT_2`, `inspectionsSection.${index}.heatLossCalReport_VPcommercial`, formik.values.inspectionsSection[index].heatLossCalReportDone, formik.values.inspectionsSection[index].heatLossCalReportDateApproved, formik.values.inspectionsSection[index].heatLossCalReportUploadedToBT_1, formik.values.inspectionsSection[index].heatLossCalReportPMCommnets, formik.values.inspectionsSection[index].heatLossCalReportUploadedToBT_2, formik.values.inspectionsSection[index].heatLossCalReport_VPcommercial,)}

                        {section_2_Body(`City framing inspection`, `inspectionsSection.${index}.cityFramingInspectionDone`, `inspectionsSection.${index}.cityFramingInspectionDateApproved`, `inspectionsSection.${index}.cityFramingInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityFramingInspectionPMCommnets`, `inspectionsSection.${index}.cityFramingInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityFramingInspection_VPcommercial`, formik.values.inspectionsSection[index].cityFramingInspectionDone, formik.values.inspectionsSection[index].cityFramingInspectionDateApproved, formik.values.inspectionsSection[index].cityFramingInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityFramingInspectionPMCommnets, formik.values.inspectionsSection[index].cityFramingInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityFramingInspection_VPcommercial,)}

                        {section_2_Body(`City sheeting inspection`, `inspectionsSection.${index}.citySheetingInspectionDone`, `inspectionsSection.${index}.citySheetingInspectionDateApproved`, `inspectionsSection.${index}.citySheetingInspectionUploadedToBT_1`, `inspectionsSection.${index}.citySheetingInspectionPMCommnets`, `inspectionsSection.${index}.citySheetingInspectionUploadedToBT_2`, `inspectionsSection.${index}.citySheetingInspection_VPcommercial`, formik.values.inspectionsSection[index].citySheetingInspectionDone, formik.values.inspectionsSection[index].citySheetingInspectionDateApproved, formik.values.inspectionsSection[index].citySheetingInspectionUploadedToBT_1, formik.values.inspectionsSection[index].citySheetingInspectionPMCommnets, formik.values.inspectionsSection[index].citySheetingInspectionUploadedToBT_2, formik.values.inspectionsSection[index].citySheetingInspection_VPcommercial,)}

                        {section_2_Body(`City Rain screen inspection`, `inspectionsSection.${index}.cityRainScreenInspectionDone`, `inspectionsSection.${index}.cityRainScreenInspectionDateApproved`, `inspectionsSection.${index}.cityRainScreenInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityRainScreenInspectionPMCommnets`, `inspectionsSection.${index}.cityRainScreenInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityRainScreenInspection_VPcommercial`, formik.values.inspectionsSection[index].cityRainScreenInspectionDone, formik.values.inspectionsSection[index].cityRainScreenInspectionDateApproved, formik.values.inspectionsSection[index].cityRainScreenInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityRainScreenInspectionPMCommnets, formik.values.inspectionsSection[index].cityRainScreenInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityRainScreenInspection_VPcommercial,)}

                        {section_2_Body(`City Stucco wire inspection`, `inspectionsSection.${index}.cityStuccoWireInspectionDone`, `inspectionsSection.${index}.cityStuccoWireInspectionDateApproved`, `inspectionsSection.${index}.cityStuccoWireInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityStuccoWireInspectionPMCommnets`, `inspectionsSection.${index}.cityStuccoWireInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityStuccoWireInspection_VPcommercial`, formik.values.inspectionsSection[index].cityStuccoWireInspectionDone, formik.values.inspectionsSection[index].cityStuccoWireInspectionDateApproved, formik.values.inspectionsSection[index].cityStuccoWireInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityStuccoWireInspectionPMCommnets, formik.values.inspectionsSection[index].cityStuccoWireInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityStuccoWireInspection_VPcommercial,)}

                        {section_2_Body(`City electrical rough inspection`, `inspectionsSection.${index}.cityElectricalRoughInspectionDone`, `inspectionsSection.${index}.cityElectricalRoughInspectionDateApproved`, `inspectionsSection.${index}.cityElectricalRoughInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityElectricalRoughInspectionPMCommnets`, `inspectionsSection.${index}.cityElectricalRoughInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityElectricalRoughInspection_VPcommercial`, formik.values.inspectionsSection[index].cityElectricalRoughInspectionDone, formik.values.inspectionsSection[index].cityElectricalRoughInspectionDateApproved, formik.values.inspectionsSection[index].cityElectricalRoughInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityElectricalRoughInspectionPMCommnets, formik.values.inspectionsSection[index].cityElectricalRoughInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityElectricalRoughInspection_VPcommercial,)}

                        {section_2_Body(`City plumbing rough in inspection`, `inspectionsSection.${index}.cityPlumbingRoughInInspectionDone`, `inspectionsSection.${index}.cityPlumbingRoughInInspectionDateApproved`, `inspectionsSection.${index}.cityPlumbingRoughInInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityPlumbingRoughInInspectionPMCommnets`, `inspectionsSection.${index}.cityPlumbingRoughInInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityPlumbingRoughInInspection_VPcommercial`, formik.values.inspectionsSection[index].cityPlumbingRoughInInspectionDone, formik.values.inspectionsSection[index].cityPlumbingRoughInInspectionDateApproved, formik.values.inspectionsSection[index].cityPlumbingRoughInInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityPlumbingRoughInInspectionPMCommnets, formik.values.inspectionsSection[index].cityPlumbingRoughInInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityPlumbingRoughInInspection_VPcommercial,)}

                        {section_2_Body(`City insulation inspection`, `inspectionsSection.${index}.cityInsulationInspectionDone`, `inspectionsSection.${index}.cityInsulationInspectionDateApproved`, `inspectionsSection.${index}.cityInsulationInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityInsulationInspectionPMCommnets`, `inspectionsSection.${index}.cityInsulationInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityInsulationInspection_VPcommercial`, formik.values.inspectionsSection[index].cityInsulationInspectionDone, formik.values.inspectionsSection[index].cityInsulationInspectionDateApproved, formik.values.inspectionsSection[index].cityInsulationInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityInsulationInspectionPMCommnets, formik.values.inspectionsSection[index].cityInsulationInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityInsulationInspection_VPcommercial,)}

                        {section_2_Body(`Initial blower door test`, `inspectionsSection.${index}.initialBlowerDoorTestDone`, `inspectionsSection.${index}.initialBlowerDoorTestDateApproved`, `inspectionsSection.${index}.initialBlowerDoorTestUploadedToBT_1`, `inspectionsSection.${index}.initialBlowerDoorTestPMCommnets`, `inspectionsSection.${index}.initialBlowerDoorTestUploadedToBT_2`, `inspectionsSection.${index}.initialBlowerDoorTest_VPcommercial`, formik.values.inspectionsSection[index].initialBlowerDoorTestDone, formik.values.inspectionsSection[index].initialBlowerDoorTestDateApproved, formik.values.inspectionsSection[index].initialBlowerDoorTestUploadedToBT_1, formik.values.inspectionsSection[index].initialBlowerDoorTestPMCommnets, formik.values.inspectionsSection[index].initialBlowerDoorTestUploadedToBT_2, formik.values.inspectionsSection[index].initialBlowerDoorTest_VPcommercial,)}

                        {section_2_Body(`Aerobarrier/Final blower door test`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTestDone`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTestDateApproved`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTestUploadedToBT_1`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTestPMCommnets`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTestUploadedToBT_2`, `inspectionsSection.${index}.aerobarrierFinalBlowerDoorTest_VPcommercial`, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTestDone, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTestDateApproved, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTestUploadedToBT_1, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTestPMCommnets, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTestUploadedToBT_2, formik.values.inspectionsSection[index].aerobarrierFinalBlowerDoorTest_VPcommercial,)}

                        {section_2_Body(`City final inspection`, `inspectionsSection.${index}.cityFinalInspectionDone`, `inspectionsSection.${index}.cityFinalInspectionDateApproved`, `inspectionsSection.${index}.cityFinalInspectionUploadedToBT_1`, `inspectionsSection.${index}.cityFinalInspectionPMCommnets`, `inspectionsSection.${index}.cityFinalInspectionUploadedToBT_2`, `inspectionsSection.${index}.cityFinalInspection_VPcommercial`, formik.values.inspectionsSection[index].cityFinalInspectionDone, formik.values.inspectionsSection[index].cityFinalInspectionDateApproved, formik.values.inspectionsSection[index].cityFinalInspectionUploadedToBT_1, formik.values.inspectionsSection[index].cityFinalInspectionPMCommnets, formik.values.inspectionsSection[index].cityFinalInspectionUploadedToBT_2, formik.values.inspectionsSection[index].cityFinalInspection_VPcommercial,)}


                      </tbody>
                    </table>
                  </div>
                </AccordionTab>
              ))}

              {/* Section 3 */}
              <AccordionTab header="LIST ALL LABOUR" className="mt-2" >
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "400px" }}>
                          List All Labour
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Hours P/W in GR
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Project Months in GR
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Contract Budget Amount
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Budget Used (time clock)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Remaining Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Charge out Rate
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Projected Completion Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated Hours to complete P/M
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Estimated # of Months to Compete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Projected Hours to Complete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Projected Budget to Compete
                        </th>
                        <th style={{ ...headerStyle, minWidth: "140px" }}>
                          Plus/Minus Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "240px" }}>
                          Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "100px" }}>
                          Add Remove Rows
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {Section3Array.map((item, index) => (

                        <tr>
                          <td style={{ ...cellStyleW }}>{renderTextArea(`section_3[${index}].ListAllLIDALabour`, '', formik.values.section_3[index].ListAllLIDALabour)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputArea(`section_3[${index}].EstimatedHoursGR`, '', '', formik.values.section_3[index].EstimatedHoursGR)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputArea(`section_3[${index}].EstimatedProjectMonthsInGR`, '', '', formik.values.section_3[index].EstimatedProjectMonthsInGR)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputAreaForAmount(`section_3[${index}].ContractBudgetAmount`, formik.values.section_3[index].ContractBudgetAmount)}</td>
                          <td style={{ ...cellStyleW }}>{renderInputAreaForAmount(`section_3[${index}].BudgetUsed`, formik.values.section_3[index].BudgetUsed)}</td>
                          <td style={{ ...cellStyle, textAlign: 'center' }}>
                            {priceBodyTemplatee(formik.values.section_3[index].ContractBudgetAmount - formik.values.section_3[index].BudgetUsed)}
                          </td>
                          <td style={cellStyleW}>{renderInputAreaForAmount(`section_3[${index}].ChargeOutRate`, formik.values.section_3[index].ChargeOutRate)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_3[${index}].ProjectedCompletionDate`, '', 'date', formik.values.section_3[index].ProjectedCompletionDate)}</td>
                          <td style={cellStyleW}>{renderInputAreaForHour(`section_3[${index}].EstimatedHoursToCompletePM`, formik.values.section_3[index].EstimatedHoursToCompletePM)}</td>
                          <td style={cellStyleW}>{renderInputAreaForHour(`section_3[${index}].EstimatedOfMonthsToCompete`, formik.values.section_3[index].EstimatedOfMonthsToCompete)}</td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}> {priceBodyTemplatee(formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete)} </td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}> {priceBodyTemplatee(formik.values.section_3[index].ChargeOutRate * formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete)} </td>

                          <td style={{ ...cellStyle, textAlign: 'center' }}>
                            {priceBodyTemplatee((formik.values.section_3[index].ContractBudgetAmount - formik.values.section_3[index].BudgetUsed) - (formik.values.section_3[index].ChargeOutRate * formik.values.section_3[index].EstimatedHoursToCompletePM * formik.values.section_3[index].EstimatedOfMonthsToCompete))}
                          </td>
                          <td style={{ ...cellStyleW }}>{renderTextAreaFull(`section_3[${index}].Comments`, '', formik.values.section_3[index].Comments)}</td>

                          <td style={cellStyleW}>
                            {formik.values.section_3.length != 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection3Array(index)} />) : null}

                            {formik.values.section_3.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection3Array()} />

                            ) : null}

                          </td>

                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 4 */}
              <AccordionTab header="GROSS PROFIT PER MONTH" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>

                        <th style={{ ...headerStyle, width: "400px" }}>
                          Forecasted # of Months
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Actual # of Months
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Original Expected GP
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Original GP Months
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          New Expected GP
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Updated GP/Month
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          GP -/+ Term of Project/Month
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          GP -/+ Term of Project
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          % of GP Slippage
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td style={cellStyleW}> {renderInputArea(`actualContractDurationMonths`)}</td>
                        <td style={cellStyleW}> {renderInputArea(`monthsOfSlippageMonths`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`originalExpectedGP`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`originalGPMonths`)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`newExpectedGP`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`updatedGPMonths`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`gpTermsOfProjectPerMonths`,)}</td>
                        <td style={cellStyleW}> {renderInputAreaForAmount(`gpTermsOfProject`)}</td>
                        <td style={cellStyleW}> {renderPercentageInputArea(`perOfGPSlippage`)}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 5 */}
              <AccordionTab header="FEES AND REIMBURSABLES" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Fees and Reimbursables
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Budget Used
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Remaining Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          When to Invoice
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Vp Construction Ops Comments Only
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {section_5_Body('Mark up', '20% contract sign, 20% foundation complete, 20% lock up, 20% rough in complete, 10% drywall complete, 5% cabinets installed, 5% substantial completion - 5% cabinets milestone being billed on next client invoice Feb 15/23', 'markupBudget', 'markupBudgetUsed', 'markupRemainingBudget', 'markupVPCOPSCO', 'markupWhenToInvoice')}


                      {section_5_Body('Overhead', 'Same as above', 'overheadBudget', 'overheadBudgetUsed', 'overheadRemainingBudget', 'overheadVPCOPSCO', 'overheadWhenToInvoice')}


                      {section_5_Body('Delivery Charge', 'Billing on going', 'deliveryChargeBudget', 'deliveryChargeBudgetUsed', 'deliveryChargeRemainingBudget', 'deliveryChargeVPCOPSCO', 'deliveryChargeWhenToInvoice')}

                      {section_5_Body('Equipment & Tool Usage', '50% at first invoice after excavation, 50% lock up', 'equipmentAndToolUsageBudget', 'equipmentAndToolUsageBudgetUsed', 'equipmentAndToolUsageRemainingBudget', 'equipmentAndToolUsageVPCOPSCO', 'equipmentAndToolUsageToInvoice')}

                      {section_5_Body('Liability Insurance', '50% at first invoice after excavation, 50% lock up', 'liabilityInsuranceBudget', 'liabilityInsuranceBudgetUsed', 'liabilityInsuranceRemainingBudget', 'liabilityInsuranceVPCOPSCO', 'liabilityInsuranceWhenToInvoice')}

                      {section_5_Body('Site Safety Management', '50% at first invoice after excavation, 50% lock up', 'siteSafetyManagementBudget', 'siteSafetyManagementBudgetUsed', 'siteSafetyManagementRemainingBudget', 'siteSafetyManagementVPCOPSCO', 'siteSafetyManagementWhenToInvoice')}

                      {section_5_Body('Site Security Storage', '50% at first invoice after excavation, 50% lock up', 'siteSecurityStorageBudget', 'siteSecurityStorageBudgetUsed', 'siteSecurityStorageRemainingBudget', 'siteSecurityStorageVPCOPSCO', 'siteSecurityStorageWhenToInvoice')}


                      {section_5_Body('Temp Fans and Heaters', 'Being billed on next client invoice Feb 15/23', 'tempFansAndHeatersBudget', 'tempFansAndHeatersBudgetUsed', 'tempFansAndHeatersRemainingBudget', 'tempFansAndHeatersVPCOPSCO', 'tempFansAndHeatersWhenToInvoice')}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 6 */}
              <AccordionTab header="MONTHLY CLIENT RATING" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Monthly Client Rating
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Client Rating 1-10
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Client Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Vp Construction Ops Comments Only
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {/* monthlyClientRating */}
                      {PMTemplate.getFormName().section_6.map((item, index) => (
                        // {monthlyClientRating.map((item, index) => (
                        <tr>
                          <td style={{ minWidth: '85px', height: '32px', border: '1px solid white' }}>{PMTemplate.getMonthName(formik.values.section_6[index].monthClientRating)}</td>
                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', textAlign: 'center' }}>{renderSelectForSection5(`section_6.${index}.ClientRating`, 'Please Select Rating', PMTemplate.getRatingList(), formik.values.section_6[index].ClientRating)}</td>

                          <td style={cellStyleW}>
                            {renderTextAreadis(`section_6.${index}.clientComment`, '', formik.values.section_6[index].clientComment)}
                          </td>
                          <td style={cellStyleW}>
                            {renderTextAreadis(`section_6.${index}.VpConstructionComment`, '', formik.values.section_6[index].VpConstructionComment)}
                          </td>


                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 7 */}
              <AccordionTab header="WEEKLY PROJECT MANAGER UPDATE" className="mt-2" >
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Weekly Project Manager Update
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ ...borderStyle, minWidth: '100%', display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                          <td style={{ width: '100px' }}>Dear:  </td>
                          {renderTextArea('dear', '???? ???', '')}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                          Here Is Your Weekly Summary:
                          <sup>
                            <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From: FSA signed - Planned Completion Date ' />
                          </sup>
                        </td>
                      </tr>

                      <tr>

                        <td style={{ ...borderStyle, display: 'flex', alignItems: 'center' }}>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                          </div>

                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>From</div>

                            <input
                              type="date"
                              name="hereIsYourWeeklySummaryFrom"
                              id="hereIsYourWeeklySummaryFrom"
                              value={formik.values.hereIsYourWeeklySummaryFrom == null ? formik.values.hereIsYourWeeklySummaryFrom : !isNaN(new Date(formik.values.hereIsYourWeeklySummaryFrom).getTime()) ? new Date(formik.values.hereIsYourWeeklySummaryFrom).toISOString().split('T')[0] : formik.values.hereIsYourWeeklySummaryFrom
                              }
                              // value={formik.values['hereIsYourWeeklySummaryFrom']}
                              onChange={(e) => {
                                setExistPageWithoutSave(true);
                                formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value)
                              }}

                              style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center' }}
                            />

                          </div>

                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>To:</div>
                            <input
                              type="date"
                              name="hereIsYourWeeklySummaryTo"
                              id="hereIsYourWeeklySummaryTo"
                              // value={formik.values['hereIsYourWeeklySummaryTo']}
                              value={formik.values.hereIsYourWeeklySummaryTo == null ? formik.values.hereIsYourWeeklySummaryTo : !isNaN(new Date(formik.values.hereIsYourWeeklySummaryTo).getTime()) ? new Date(formik.values.hereIsYourWeeklySummaryTo).toISOString().split('T')[0] : formik.values.hereIsYourWeeklySummaryTo
                              }
                              onChange={(e) => {
                                setExistPageWithoutSave(true);
                                formik.setFieldValue('hereIsYourWeeklySummaryTo', e.target.value)
                              }}

                              style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center' }}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                          Project Summary:
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          {renderTextAreaFull('projectSummary', '')}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                          Schedule
                        </td>
                      </tr>

                      <tr>
                        <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                          </div>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                              Construction Start Date
                              <sup>
                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From : Site Prep - Planned Baseline Completion Date ' />
                              </sup>
                            </div>

                            <input
                              type="date"
                              name="scheduleConstructionStartDate"
                              id="scheduleConstructionStartDate"
                              // value={formik.values['scheduleConstructionStartDate']}
                              value={formik.values.scheduleConstructionStartDate == null ? formik.values.scheduleConstructionStartDate : !isNaN(new Date(formik.values.scheduleConstructionStartDate).getTime()) ? new Date(formik.values.scheduleConstructionStartDate).toISOString().split('T')[0] : formik.values.scheduleConstructionStartDate
                              }
                              onChange={(e) => {
                                setExistPageWithoutSave(true);
                                formik.setFieldValue('scheduleConstructionStartDate', e.target.value)
                              }}

                              readOnly
                              style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', background: "#FFE1FF", textAlign: 'center' }}
                            />
                          </div>

                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ width: '25%', marginRight: '15px' }}>
                            </div>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                              {internalJob === 'Y' ? 'Construction Completion' : 'Project Turn Over'}
                              <sup>
                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From : Turn Over - Current Forecast Completion Date' />
                              </sup>
                            </div>

                            <input
                              type="date"
                              name="scheduleProjectCompletion"
                              id="scheduleProjectCompletion"
                              // value={formik.values['scheduleProjectCompletion']}
                              value={formik.values.scheduleProjectCompletion == null ? formik.values.scheduleProjectCompletion : !isNaN(new Date(formik.values.scheduleProjectCompletion).getTime()) ? new Date(formik.values.scheduleProjectCompletion).toISOString().split('T')[0] : formik.values.scheduleProjectCompletion
                              }
                              onChange={(e) => {
                                formik.setFieldValue('scheduleProjectCompletion', e.target.value)
                                setExistPageWithoutSave(true);
                              }}

                              readOnly
                              style={{
                                width: '100%',
                                height: '40px',
                                boxSizing: 'border-box',
                                border: 'none',
                                background: internalJob === 'Y' ? '#96CEB4' : '#FFCFB3',
                                textAlign: 'center'
                              }}
                            />
                          </div>

                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 8 */}

              {scheduleMilestonesSection.map((item, index) => (
                <AccordionTab header={
                  <div className="flex justify-between items-center w-full accodianBtn" >

                    <span className="font-bold white-space-nowrap ">SCHEDULE MILESTONES {getTitleForInspectionsSection[index]}</span>

                    <div className="flex items-center space-x-2">
                      {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForScheduleMilestonesSection(index)} />) : null}

                      {scheduleMilestonesSection.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddScheduleMilestonesSection(index)} />) : null}
                    </div>
                  </div>
                } className="mt-2" >
                  <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]} >
                    <table style={{ borderCollapse: "collapse", }}>
                      <thead>
                        <tr>
                          <th style={{ ...headerStyle, width: "400px" }}>
                            Schedule Milestones
                          </th>
                          <th style={{ ...headerStyle, minWidth: "auto" }}>
                            Planned Baseline Completion Date
                          </th>
                          <th style={{ ...headerStyle, minWidth: "auto" }}>
                            Current Forecast Completion Date
                          </th>
                          <th style={{ ...headerStyle, minWidth: "auto" }}>
                            Actual Completion Date
                          </th>
                          <th style={{ ...headerStyle, minWidth: "auto" }}>
                            Notes:  If applicable, explain why there was a change fo the schedule
                          </th>
                        </tr>
                      </thead>
                      <tbody>


                        {section_8_Body(`Site Prep`, `scheduleMilestonesSectionList.${index}.sitePrep_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_A_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_Notes`, `scheduleMilestonesSectionList.${index}.sitePrep_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].sitePrep_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_A_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_Notes, formik.values.scheduleMilestonesSectionList[index].sitePrep_VP_C_Comments,)}


                        {section_8_Body(`Demolition and Survey`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_A_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_Notes`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_A_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_Notes, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_VP_C_Comments,)}

                        {section_8_Body(`Footings and Foundation`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_A_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_Notes`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_A_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_Notes, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_VP_C_Comments,)}


                        {section_8_Body(`Framing`, `scheduleMilestonesSectionList.${index}.framing_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.framing_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.framing_A_C_Date`, `scheduleMilestonesSectionList.${index}.framing_Notes`, `scheduleMilestonesSectionList.${index}.framing_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].framing_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_A_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_Notes, formik.values.scheduleMilestonesSectionList[index].framing_VP_C_Comments,)}


                        {section_8_Body(`Roofing and Mechanical`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_A_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_Notes`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_A_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_Notes, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_VP_C_Comments,)}


                        {section_8_Body(`Exterior Finish`, `scheduleMilestonesSectionList.${index}.exteriorFinish_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_A_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_Notes`, `scheduleMilestonesSectionList.${index}.exteriorFinish_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_A_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_Notes, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_VP_C_Comments,)}

                        {section_8_Body(`Insulation and Drywall`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_A_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_Notes`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_A_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_Notes, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_VP_C_Comments,)}

                        {section_8_Body(`Construction Completion`, `scheduleMilestonesSectionList.${index}.Completion_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_A_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_Notes`, `scheduleMilestonesSectionList.${index}.Completion_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].Completion_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_A_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_Notes, formik.values.scheduleMilestonesSectionList[index].Completion_VP_C_Comments,)}

                        {section_8_Body(`Project Turn Over`, `scheduleMilestonesSectionList.${index}.turnOver_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_A_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_Notes`, `scheduleMilestonesSectionList.${index}.turnOver_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].turnOver_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_A_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_Notes, formik.values.scheduleMilestonesSectionList[index].turnOver_VP_C_Comments,)}

                        {section_8_Body(`Final Invoice`, `scheduleMilestonesSectionList.${index}.finalInvoice_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.finalInvoice_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.finalInvoice_A_C_Date`, `scheduleMilestonesSectionList.${index}.finalInvoice_Notes`, `scheduleMilestonesSectionList.${index}.finalInvoice_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].finalInvoice_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].finalInvoice_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].finalInvoice_A_C_Date, formik.values.scheduleMilestonesSectionList[index].finalInvoice_Notes, formik.values.scheduleMilestonesSectionList[index].finalInvoice_VP_C_Comments,)}

                      </tbody>
                    </table>
                  </div>
                </AccordionTab>
              ))}

              {/* Section 9*/}
              <AccordionTab header="ACTIVITIES WORKED ON THIS WEEK" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Activities worked on this week: (Description)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Contractor
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Brief Scope of Work
                        </th>
                        <th style={{ ...headerStyle, width: "250px" }}>
                          Current Forecasted Completion Date
                        </th>

                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      {Section9Array.map((item, index) => (
                        <tr>

                          <td style={cellStyleW}>{renderTextAreaFull(`section_9.${index}.activitiesworkedOnThisWeek`, '', formik.values.section_9[index].activitiesworkedOnThisWeek)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_9.${index}.Constractor`, '', '', formik.values.section_9[index].Constractor)}</td>
                          <td style={cellStyleW}>
                            {renderTextAreaFull(`section_9.${index}.briefScopeOfWeek`, '', formik.values.section_9[index].briefScopeOfWeek)}
                          </td>
                          <td style={cellStyleW}>{renderInputArea(`section_9.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_9[index].CurrentForecastedCompletionDate)}</td>

                          <td style={cellStyleW}>
                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection9Array(index)} />) : null}

                            {formik.values.section_9.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection9Array()} />

                            ) : null}

                          </td>
                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 10 */}
              <AccordionTab header="ACTIVITIES SCHEDULED FOR NEXT WEEK" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Activities Scheduled for Next Week: (Description)
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Contractor
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Brief Scope of Work
                        </th>
                        <th style={{ ...headerStyle, width: "250px" }}>
                          Current Forecasted Completion Date
                        </th>

                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>

                      {Section10Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextAreaFull(`section_10.${index}.activitiesScheduledOnNextWeek`, '', formik.values.section_10[index].activitiesScheduledOnNextWeek)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_10.${index}.Constractor`, '', '', formik.values.section_10[index].Constractor)}</td>
                          <td style={cellStyleW}>
                            {renderTextAreaFull(`section_10.${index}.briefScopeOfWeek`, '', formik.values.section_10[index].briefScopeOfWeek)}
                          </td>
                          <td style={cellStyleW}>{renderInputArea(`section_10.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_10[index].CurrentForecastedCompletionDate)}</td>

                          <td style={cellStyleW}>
                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection10Array(index)} />) : null}

                            {formik.values.section_10.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection10Array()} />

                            ) : null}

                          </td>

                          {/* <td style={cellStyleW}>
                            {formik.values.section_10.length != 1 ? (<Button type="button" icon="pi pi-trash" rounded outlined style={{ width: '30px', height: '30px' }} className="mr-2" severity="danger" onClick={() => handleDeleteInputForSection10Array(index)} />) : null}
                            
                            {formik.values.section_10.length - 1 == index ? (<Button type="button" icon="pi pi-plus" rounded outlined style={{ width: '30px', height: '30px' }} className="mr-2" onClick={() => handleAddInputForSection10Array()} />

                            ) : null}

                          </td> */}

                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 11 */}
              <AccordionTab header="PROJECT BUDGET" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[4]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Project Budget
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Amount
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {section_11_Body('Contract Price', 'contractPriceAmount', 'contractPriceVPCComment')}
                      {section_11_Body('Approved Change Order Price', 'approvedChangeOrderPrice', 'approvedChangeOrderVPCComment')}
                      {section_11_Body('Allowance Difference (Selections to Date)', 'allowanceDiffrence', 'allowanceDiffrenceVPCComment')}
                      {section_11_Body('Job Running Total', 'jobRunningTotal', 'jobRunningTotalVPCComment')}
                      {section_11_Body('GST', 'gst', 'gstVPCComment')}
                      {section_11_Body('Amount Paid ', 'amountPaid', 'amountPaidVPCComment')}
                      {section_11_Body('Balance (Not Including Deposit)', 'balance', 'balanceVPCComment')}


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 12 */}
              <AccordionTab header="PROJECT DEPOSITS" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[5]}>
                  <table style={{ borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Project Deposits
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Amount
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {section_11_Body('Contract Deposits', 'contractDepositsAmount', 'contractDepositsVPCComments')}
                      {section_11_Body('Building Permit Deposit', 'buildingPermitDepositAmount', 'buildingPermitDepositVPCComments')}
                      {section_11_Body('Other Deposits', 'otherDepositAmount', 'otherDepositVPCComments')}
                      {section_11_Body('Total Deposits', 'totalDepositAmount', 'totalDepositVPCComments')}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 13 */}
              <AccordionTab header="CHANGE WORK ORDERS" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[6]}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>
                          Change Work Orders (# and Description)
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }}>
                          Date
                        </th>
                        <th style={{ ...headerStyle, width: "200px" }}>
                          Amount
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Approved
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Notes
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {Section13Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextAreaFull(`section_13.${index}.changeWorkOrder`, '', formik.values.section_13[index].changeWorkOrder)}</td>
                          <td style={cellStyleW}>{renderInputArea(`section_13.${index}.date`, '', 'date', formik.values.section_13[index].date)}</td>
                          <td style={cellStyleW}>{renderInputAreaForAmount(`section_13.${index}.amount`, formik.values.section_13[index].amount)}</td>

                          <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
                            {renderSelect1(`section_13.${index}.approved`, formik.values.section_13[index].approved)}
                          </td>

                          <td style={cellStyleW}>
                            {renderTextAreaFull(`section_13.${index}.notes`, '', formik.values.section_13[index].notes)}
                          </td>

                          <td style={cellStyleW}>
                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection13Array(index)} />) : null}

                            {Section13Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection13Array()} />

                            ) : null}

                          </td>
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 14 */}
              <AccordionTab header="ACTION ITEMS DISCUSSED" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[7]} >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "auto" }}>
                          Action Items Discussed
                        </th>

                        <th style={{ ...headerStyle, width: "100px" }}>
                          Add Remove Rows
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {Section14Array.map((item, index) => (
                        <tr>
                          <td style={cellStyleW}>{renderTextAreaFull(`section_14.${index}.actionItemDiscussed`, '', formik.values.section_14[index].actionItemDiscussed)}</td>


                          <td style={cellStyleW}>
                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection14Array(index)} />) : null}

                            {Section14Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection14Array()} />

                            ) : null}
                          </td>
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </AccordionTab>

              {/* Section 14-B */}
              <AccordionTab header="VP CONSTRUCTION OPS COMMENTS ONLY" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}  >
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          Vp Construction Ops Comments Only
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cellStyleW}>
                          {renderTextAreaFull(`vpConstructionCommentsForAll`, '', '', 6)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

            </Accordion>
          </div>
        </form >

      )}

    </>
  );
};

export default EDIT_SP_TEMPLATE;
